import { MapPin, Clock, HandCoins, Truck, Star } from "lucide-react";
import { Eyebrow } from "./Brand";
import { Reveal } from "./Motion";
import { VEHICLES } from "@/lib/api";

const Tile = ({ className = "", children, delay = 0, testId }) => (
  <Reveal delay={delay} className={className}>
    <div data-testid={testId} className="h-full rounded-[28px] p-7 sm:p-9 transition-transform duration-500 hover:-translate-y-1">{children}</div>
  </Reveal>
);

export const DriverBento = () => (
  <section id="drivers" className="py-20 sm:py-32 bg-[#F7F9FC]" data-testid="driver-benefits-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-10">
      <Reveal className="max-w-3xl">
        <Eyebrow>For drivers · priority sign-up</Eyebrow>
        <h2 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tight text-[#13296B] mt-4 leading-[0.95]">Turn your car, van or truck into income.</h2>
        <p className="mt-6 text-base sm:text-lg text-slate-600 max-w-2xl">Accept the jobs that fit your schedule and your vehicle. Drivers who sign up now get first access when Marketgetr launches in their area.</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-6 gap-4 sm:gap-5 auto-rows-[minmax(220px,auto)]">
        <Tile className="md:col-span-4 md:row-span-2 [&>div]:bg-[#13296B] [&>div]:text-white" testId="bento-vehicles">
          <Truck className="h-9 w-9 text-[#2F7FF0]" />
          <h3 className="font-display text-3xl sm:text-5xl font-extrabold mt-6 leading-[0.95]">Every vehicle<br />has a job.</h3>
          <p className="mt-4 text-slate-300 max-w-md">See nearby jobs filtered by your vehicle type, from a couch to a pallet.</p>
          <div className="mt-8 flex flex-wrap gap-2.5">
            {VEHICLES.map((v) => (
              <span key={v} className="rounded-full border border-white/20 bg-white/5 px-4 py-2 text-sm font-semibold hover:bg-[#2F7FF0] hover:border-[#2F7FF0] transition-colors duration-300">{v}</span>
            ))}
          </div>
          <div className="road-dash h-1 w-full mt-10 opacity-80" />
        </Tile>
        <Tile className="md:col-span-2 [&>div]:bg-white [&>div]:ring-1 [&>div]:ring-slate-200" delay={0.08} testId="bento-schedule">
          <Clock className="h-8 w-8 text-[#2F7FF0]" />
          <h3 className="font-display text-2xl font-bold text-[#13296B] mt-5">Go online when you want</h3>
          <p className="mt-2 text-slate-600 text-sm">Set your availability. No shifts, no boss.</p>
        </Tile>
        <Tile className="md:col-span-2 [&>div]:bg-[#2F7FF0] [&>div]:text-white" delay={0.16} testId="bento-tips">
          <HandCoins className="h-8 w-8" />
          <h3 className="font-display text-2xl font-bold mt-5">Keep your tips</h3>
          <p className="mt-2 text-white/90 text-sm">Every tip goes straight to you.</p>
        </Tile>
        <Tile className="md:col-span-3 [&>div]:bg-white [&>div]:ring-1 [&>div]:ring-slate-200" delay={0.08} testId="bento-local">
          <MapPin className="h-8 w-8 text-[#2F7FF0]" />
          <h3 className="font-display text-2xl font-bold text-[#13296B] mt-5">Local jobs near you</h3>
          <p className="mt-2 text-slate-600 text-sm">Pickups from local sellers and Marketplace finds, delivered to buyers nearby.</p>
        </Tile>
        <Tile className="md:col-span-3 [&>div]:bg-[#E3EDFC]" delay={0.16} testId="bento-rating">
          <Star className="h-8 w-8 text-[#13296B]" />
          <h3 className="font-display text-2xl font-bold text-[#13296B] mt-5">Build a 5-star rating</h3>
          <p className="mt-2 text-slate-700 text-sm">Great service earns you more jobs. Starting early gives you a head start.</p>
        </Tile>
      </div>
    </div>
  </section>
);
